import { CodeSurfer, CodeSurferColumns, Step } from 'code-surfer';
import customTheme from "../../../../../../theme.js";
import { Head, Image, Appear, Notes } from 'mdx-deck';
import 'prismjs/components/prism-php';
import React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  customTheme: customTheme,
  Head: Head,
  Image: Image,
  Appear: Appear,
  Notes: Notes,
  React: React
};